import React from 'react';
import { Stack, Text } from '@alefeducation/ui-elements-library-core';
import styled from 'styled-components';
import {
  CODE,
  COUNTRY,
  E_MAIL,
  ORGANISATION_NAME,
  STATUS,
} from '../../utils/constants';
import { defaultHeaderStyles } from '../../styles/Common';

const StyledHeader = styled.div`
  ${defaultHeaderStyles};

  > div {
    width: 20%;
  }

  .status-container,
  .action-container {
    width: 10%;
  }
`;

const colTitles = [
  { title: ORGANISATION_NAME, className: '' },
  { title: CODE, className: '' },
  { title: E_MAIL, className: '' },
  { title: COUNTRY, className: '' },
  { title: STATUS, className: 'status-container' },
  { title: '', className: 'action-container' },
];

const OrgColHeader = () => {
  return (
    <StyledHeader>
      {colTitles.map((column) => (
        <Stack
          className={column.className}
          flexDirection="column"
          justifyContent="center"
          key={column.title}
        >
          <Text variant="body-large" color="primary.60" weight="light">
            {column.title}
          </Text>
        </Stack>
      ))}
    </StyledHeader>
  );
};

export default OrgColHeader;
